document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".qb-card");
  const nativeQtyInput = document.querySelector('input[name="quantity"]');
  const addToCartBtn = document.querySelector('button[name="add"] span') || 
                       document.querySelector('.add-to-cart-text') ||
                       document.querySelector('button[name="add"]');
  
  const formatMoney = (cents) => {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  };

  const updateButtonText = (qty) => {
    if (!addToCartBtn) return;
    addToCartBtn.innerText = qty > 1 ? "Agregar pack al carrito y ahorrar" : "Agregar al carrito";
  };

  const updateBundlePrices = () => {
    const priceElement = document.querySelector('.price-item--regular') || 
                         document.querySelector('.price__regular .price-item') ||
                         document.querySelector('[data-product-price]');
    
    if (!priceElement) return;

    const currentPriceText = priceElement.innerText.replace(/[^0-9]/g, '');
    const currentPrice = parseInt(currentPriceText) * 100;

    cards.forEach(card => {
      const qty = parseInt(card.dataset.qty);
      const oldPrice = card.querySelector('.qb-old-price');
      const newPrice = card.querySelector('.qb-new-price');
      const savingsMoney = card.querySelector('.qb-savings-money');
      const singlePrice = card.querySelector('.qb-price');

      // Actualización alineada para unidad individual
      if (qty === 1 && newPrice) {
        newPrice.innerText = formatMoney(currentPrice);
      }

      if (qty > 1) {
        const discountPercent = (qty >= 3) ? 0.15 : 0.10;
        const savingsAmount = currentPrice * discountPercent;
        const discountedUnitPrice = currentPrice * (1 - discountPercent);

        if (savingsMoney) savingsMoney.innerText = formatMoney(savingsAmount);
        if (oldPrice) oldPrice.innerText = formatMoney(currentPrice);
        if (newPrice) newPrice.innerText = `${formatMoney(discountedUnitPrice)} c/u`;
      }
    });
  };

  cards.forEach(card => {
    card.addEventListener("click", function() {
      cards.forEach(c => c.classList.remove("active"));
      this.classList.add("active");

      const qty = parseInt(this.dataset.qty);
      if (nativeQtyInput) {
        nativeQtyInput.value = qty;
        nativeQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateButtonText(qty);
    });
  });

  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('change', () => {
      setTimeout(updateBundlePrices, 100);
    });
  }

  updateBundlePrices();
});